<span class="dx-popup-custom-title dx-popup-custom-title--small">{{message}}</span>
<div class="buttons-container confirmation-popup-controls">
  <div
    (click)="confirm()"
    class="iv-flat-button button confirmation-popup-confirm-btn"
    statistic
    [statisticElementName]="confirmButtonStatisticName"
  >
    <span>{{confirmButtonText}}</span>
  </div>
  <div
    (click)="close()"
    class="iv-flat-button iv-flat-button-alert button cancel confirmation-popup-cancel-btn"
    statistic
    [statisticElementName]="cancelButtonStatisticName"
  >
    <span>Cancel</span>
  </div>
</div>
